export default "__VITE_ASSET__Dg09gE2S__"